module.exports = __webpack_public_path__ + "static/media/MainLandingPageHero.198e3c8d.png";